// Only the first portion of the text is sent when previewing the speech.
export const SPEECH_PREVIEW_MAX_LENGTH = 150

/**
 * Trim `text` to at most `SPEECH_PREVIEW_MAX_LENGTH` characters without cutting a
 * word in half. If the whole text already fits, it's returned unchanged.
 * Otherwise we keep only the words that fit fully within the limit — a word that
 * would be split is dropped entirely. The one exception: if the very first word
 * is already longer than the limit, that whole word is kept so we never return
 * an empty preview.
 */
export const getSpeechPreviewText = (text: string): string => {
  const trimmed = text.trim()
  if (trimmed.length <= SPEECH_PREVIEW_MAX_LENGTH) return trimmed

  const sliced = trimmed.slice(0, SPEECH_PREVIEW_MAX_LENGTH)
  // If the char right after the cut is whitespace, the slice ended on a word
  // boundary and nothing is mid-word; otherwise drop the partial trailing word.
  if (/\s/.test(trimmed[SPEECH_PREVIEW_MAX_LENGTH])) return sliced.trimEnd()

  const lastSpace = sliced.lastIndexOf(' ')
  // No earlier word boundary means the very first word is longer than the limit.
  // Keep that whole word (extend past the limit) rather than returning nothing.
  if (lastSpace === -1) {
    const firstSpace = trimmed.indexOf(' ')
    return firstSpace === -1 ? trimmed : trimmed.slice(0, firstSpace)
  }
  return sliced.slice(0, lastSpace)
}
